import React from "react";
//Utils
import { dateToString } from "../../utils";
// Components
import HorizontalCard from "../generic/HorizontalCard";
// Styled
import styled from "styled-components";
// React Router
import { useHistory } from "react-router-dom";

const CardLaico = styled(HorizontalCard).attrs(props => ({

  backgroundColor: props.accesible ? "#F0F8FF" : "#FFF0F0",
  grayscale: props.active ? 0 : 100,
  shadow: props.active ? "0 0px 6px #2a599f !important" : "0 0px 6px #93a1b4 !important"

}))`

  -webkit-filter: grayscale(${props => props.grayscale}); /* Safari 6.0 - 9.0 */
  filter: grayscale(${props => props.grayscale});

  :hover {
    box-shadow: 0 0px 6px #876642 !important;
    background-color: ${props => props.backgroundColor};
  }
`;

const LaicoTarjeta = ({ content, provinciaLogueado, ...props }) => {

  let history = useHistory();

  // Procesamiento de los datos del Laico
  let imgM = "/images/laico2.png";
  let imgH = "/images/laico1.png";

  let defaultImage = content.gender === "h" ? imgH : imgM;
  let img = content.photo ? `${process.env.REACT_APP_API_URL}/download/usuarios/${content.id}` : defaultImage;
  let imgOnError = defaultImage;
  let title = `${content.name} ${content.firstSurname} ${content.secondSurname}`;
  let years = content.birthdate ? `${dateToString(content.birthdate)}` : "";
  let address = content.birthCountry ? `${content.birthCountry}` : "";

  // TODO añadir provincia
  let body = [
    { img: { url: "/images/address.png", size: 20, title: "País de nacimiento" }, value: address ? address : "No especificada" },
    { img: { url: "/images/birthday-cake.png", size: 20, title: "Fecha nacimiento" }, value: years ? years : "No especificada" },
    { img: { url: "/images/province.png", size: 20, title: "Provincia" }, value: content.destinationLaicos[0] ? content.destinationLaicos[0].province.name : "No asignada" },
    { img: { url: "/images/calendar.png", size: 20, title: "Fechas" }, value: content.destinationLaicos[0] ? `De ${content.destinationLaicos[0].startDate} ${content.destinationLaicos[0].endDate ? ` a ${content.destinationLaicos[0].endDate}` : ` a la actualidad`}` : "No asignada" },
  ];
console.log(props.userLevel)
  return (

    <CardLaico
      onClick={provinciaLogueado.id === content?.destinationLaicos[0]?.provinceId || props.userLevel >= 10 ? () => { history.push(`laicos/${content.id}`); } : null}
      cardImage={img}
      title={title}
      body={body}
      imgOnError={imgOnError}
      active={content.active}
      accesible={(provinciaLogueado?.id === content.destinationLaicos[0]?.provinceId) || props.userLevel >= 10 ? true : false}
      {...props}>

    </CardLaico>

  );
};

export default LaicoTarjeta;
